export const depenses = [
  {
    title: 'Vie sociale',
    color: '#10253F',
    percent: 18.42,
    subtitle:
      'Protection de l’enfance, Solidarité, Cohésion sociale,\n' +
      'Accès au logement, Jeunesse, Sports',
  },
  {
    title: 'Partenariat avec les collectivités',
    color: '#17375E',
    percent: 10.39,
    subtitle:
      'Partenariat avec les communes et les archipels, Aménagement du territoire et risques naturels,\n' +
      'Projets pilotes de développement durable, Equipements et aménagements à vocation collective',
  },
  {
    title: 'Gestion financière',
    color: '#558ED5',
    percent: 12.06,
    subtitle:
      'Engagements financiers (annuité de la dette),\n' +
      'Autofinancement net, Opérations diverses ou exceptionnelles',
  },
  {
    title: 'Réseaux et équipements structurants',
    color: '#8EB4E3',
    percent: 8.3,
    subtitle:
      'Réseaux routiers, Ports et aéroports, Protection contre les eaux, Energie, Postes,\n' +
      '\n' +
      'télécommunications, nouvelles technologies, Médias',
  },
  {
    title: 'Travail et emploi',
    color: '#C6D9F1',
    percent: 10.9,
    subtitle:
      'Travail, Emploi et insertion professionnelle,\n' +
      'Formation professionnelle',
  },
  {
    title: 'Santé',
    color: '#10253F',
    percent: 8.42,
    subtitle:
      'Offre de santé – Médecine curative,\n' +
      '\n' +
      'Santé publique – Prévention, Veille et sécurité sanitaires',
  },
  {
    title: 'Urbanisme, habitat et foncier',
    color: '#17375E',
    percent: 5.92,
    subtitle:
      'Urbanisme, Gestion du domaine public,\n' + 'Affaires foncières, Habitat',
  },
  {
    title: 'Enseignement',
    color: '#558ED5',
    percent: 4.4,
    subtitle:
      'Enseignement primaire, secondaire, professionnel, supérieur et recherche,\n' +
      'Soutien à l’élève, Promotion des langues polynésiennes et plurilinguisme',
  },
  {
    title: 'Gestion fiscale',
    color: '#8EB4E3',
    percent: 2.98,
    subtitle: 'Fiscalité indirecte,\n' + 'Fiscalité directe',
  },
  {
    title: 'Pouvoirs publics',
    color: '#C6D9F1',
    percent: 3.04,
    subtitle:
      'Gouvernement, Assemblée de la PF, CESEC,\n' +
      'Administration générale, Relations extérieures',
  },
  {
    title: 'Economie générale',
    color: '#10253F',
    percent: 2.75,
    subtitle: 'Régulation,\n' + 'Commerce extérieur et promotion',
  },
  {
    title: 'Développement des ressources propres',
    color: '#17375E',
    percent: 3.54,
    subtitle:
      'Agriculture et élevage, Forêts,\n' +
      'Pêche et aquaculture, Perliculture Artisanat',
  },
  {
    title: 'Transports',
    color: '#558ED5',
    percent: 3.75,
    subtitle:
      'Transports terrestres et sécurité routière, Affaires maritimes,\n' +
      'Transports aériens et aviation civile',
  },
  {
    title: 'Tourisme',
    color: '#8EB4E3',
    percent: 1.18,
    subtitle:
      'Equipements et aménagements touristiques,\n' +
      'Aide et régulation du tourisme, Animation et promotion du tourisme',
  },
  {
    title: 'Personnel',
    color: '#C6D9F1',
    percent: 1.09,
    subtitle: 'Ressources humaines,\n' + 'Rémunération et charges',
  },
  {
    title: 'Moyens internes',
    color: '#10253F',
    percent: 1.7,
    subtitle:
      'Finances, Informatique, Bâtiments du Pays,\n' +
      'Achats de matériels roulant, informatique, du bureau',
  },
  {
    title: 'Culture et patrimoine',
    color: '#17375E',
    percent: 0.72,
    subtitle:
      'Culture et art contemporain,\n' +
      'Patrimoine et transmission des savoirs traditionnels',
  },
  {
    title: 'Environnement',
    color: '#558ED5',
    percent: 0.45,
    subtitle:
      'Gestion de la biodiversité et des ressources naturelles,\n' +
      'Prévention et traitement des pollutions, Connaissance et éducation',
  },
];
